module.exports = __webpack_public_path__ + "static/media/mobile-service-android.41a50434.jpg";